import { FC, HTMLAttributes } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'
import { CartIcon } from '@/root/ui/shared'

export const CartCard: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const { getTranslation } = useGetTranslations()

  return (
    <div
      data-testid="cart-card"
      className="border-base-very-light flex min-h-32 w-full flex-col justify-between gap-4 rounded-xl border p-4"
    >
      <div className="text-primary-base xxs:text-large flex items-center justify-center gap-4 text-xl font-bold">
        <CartIcon className="shrink-0" color="primary-base" />
        <span>{getTranslation('selectedTicketsCartTitle')}</span>
      </div>
      <div className="text-base-normal-light mx-12 text-center text-sm leading-6">
        {getTranslation('selectedTicketsCartEmpty')}
      </div>
    </div>
  )
}
